import React, { useState, useEffect } from 'react'
import { isIE } from '../helper/Constants'

export default function Fade({ children, timeout = 150 }) {
  const [animated, setAnimated] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimated(true);
    }, timeout);

    return () => clearTimeout(timer);
  }, [timeout]);

  if (isIE) {
    return <>{children}</>;
  }
  
  return (
    <div 
      style={{
        opacity: animated ? 1 : 0,
        transition: `opacity ${timeout}ms ease-in-out`,
      }}
    >
      {children}
    </div>
  );
}